import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";

Vue.use(VueRouter);

const routes =  [
  // SET:Dashbaord
  {
    path: "/",
    name: "Home",
    component: Home
  },
  // SET:Register
  {
    path: "/register",
    name: "Register",
    component: () =>
    import("@/views/Register.vue")
  },
  // SET:Thank You
  {
    path: "/unsubscribe",
    name: "Unsubscribe",
    component: () =>
    import("@/views/ThankYou.vue")
  },
  {
    path: "/browser",
    name: "Browser",
    component: () =>
    import("@/views/Browser.vue")
  },
];
const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
});

export default router;
